import { render, staticRenderFns } from "./ButtonsForModals.vue?vue&type=template&id=ef374b78&"
import script from "./ButtonsForModals.vue?vue&type=script&lang=js&"
export * from "./ButtonsForModals.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsForModals.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports